/**
 * To normalize the DNI to compare
 */
const normalizeIdentifier = (id = '') =>
  String(id)
    .trim()
    .toUpperCase()
    .replace(/[.\s-]/g, '')

/**
 * To generate a key with an identifier
 */
const makeKey = (key, identifier) => `${key}_${normalizeIdentifier(identifier)}`

/**
 * To save a value in one key in local storage with expiry based on a given datetime.
 * expiryAt could be a Date, parseable string date ("2026-01-06T23:59:59-03:00") or a
 * number timestamp in ms (Date.now() style)
 */
export const setItemWithExpiryAt = (key, value, expiryAt, identifier) => {
  let expiryMs

  if (expiryAt instanceof Date) {
    expiryMs = expiryAt.getTime()
  } else if (typeof expiryAt === 'number') {
    expiryMs = expiryAt
  } else if (typeof expiryAt === 'string') {
    const parsed = new Date(expiryAt)
    if (Number.isNaN(parsed.getTime())) {
      throw new Error(`setItemWithExpiryAt: fecha inválida: "${expiryAt}"`)
    }
    expiryMs = parsed.getTime()
  } else {
    throw new Error('setItemWithExpiryAt: expiryAt debe ser Date, string o number')
  }

  const item = { value, expiry: expiryMs }
  localStorage.setItem(makeKey(key, identifier), JSON.stringify(item))
}

/**
 * To save a value in one key in local storage
 */
export const setItem = (key, value, identifier) => {
  localStorage.setItem(makeKey(key, identifier), JSON.stringify(value))
}
